// extracted by mini-css-extract-plugin
module.exports = {"descriptionInput":"update-description-component_descriptionInput__1IDkR"};